export default "__VITE_ASSET__DP_F9$3f__"